export const CACHE_ADAPTER_OPTIONS = [
  { value: "noop", label: "No-op (disabled - default)", description: "No caching. Safe for single-instance deployments." },
  { value: "redis", label: "Redis", description: "Shared cache for multi-instance deployments." },
];

export const EMAIL_ADAPTER_OPTIONS = [
  { value: "noop", label: "Disabled (no-op)" },
  { value: "aws_ses", label: "AWS SES" },
];

export const EVENT_BUS_OPTIONS = [
  { value: "pubsub", label: "Google Pub/Sub" },
  { value: "local", label: "Local (in-memory)" },
];

export const STORAGE_ADAPTER_OPTIONS = [
  { value: "gcs", label: "Google Cloud Storage" },
  { value: "s3", label: "AWS S3" },
  { value: "azure", label: "Azure Blob Storage" },
  { value: "noop", label: "Disabled (no-op)" },
];